export const groupOutboundsPerDelivery = (allOutbounds) => {
  const groupedOutbounds = {};
  allOutbounds.forEach((ob) => {
    if (!groupedOutbounds[ob.deliveryZip]) {
      groupedOutbounds[ob.deliveryZip] = {
        bestRPM: null,
        bestPrice: null,
        bestCMI: [],
        all: [],
      };
    }
    groupedOutbounds[ob.deliveryZip].all.push(ob);
    if (!groupedOutbounds[ob.deliveryZip].bestRPM || groupedOutbounds[ob.deliveryZip].bestRPM.avgRPM < ob.avgRPM) {
      groupedOutbounds[ob.deliveryZip].bestRPM = ob;
    }
    if (!groupedOutbounds[ob.deliveryZip].bestPrice || groupedOutbounds[ob.deliveryZip].bestPrice.avgPrice < ob.avgPrice) {
      groupedOutbounds[ob.deliveryZip].bestPrice = ob;
    }
    [0, 1, 2, 3, 4].forEach((index) => {
      if (!groupedOutbounds[ob.deliveryZip].bestCMI[index] || groupedOutbounds[ob.deliveryZip].bestCMI[index] < ob.CMI[index]) {
        groupedOutbounds[ob.deliveryZip].bestCMI[index] = ob;
      }
    });
  });

  return groupedOutbounds;
};

export const chooseBestOutbound = (outbounds, optimizePer, ratioMark, confidencePriority = false) => {
  return outbounds.sort((a, b) => {
    if (!confidencePriority || a.confidence === b.confidence) {
      if (optimizePer.id === "cmi") {
        return a.CMI[ratioMark] > b.CMI[ratioMark] ? -1 : 1;
      } else if (optimizePer.id === "rpm") {
        return a.avgRPM > b.avgRPM ? -1 : 1;
      } else if (optimizePer.id === "rate") {
        return a.avgPrice > b.avgPrice ? -1 : 1;
      }
    }
    if (a.confidence === "high") return a;
    if (b.confidence === "high") return b;
    if (a.confidence === "medium") return a;
    return b;
  });
};
